/**
 * Deck State actions.
 * Rotate, Zoom, Matching
 */
var VRC = VRC || {};

VRC.DeckStateActionsView = (function(){

    var $deck, $zoomInBtn, $zoomOutBtn, $rotateContainerBtn;
    var $findMatchingContainersBtn;
    var scale = 1;

    //move to Container.js
    var rotateContainer = function($containerDom){
        var containerId = $containerDom.attr('id');
        var l_container = g_container_list[containerId];

        if (l_container !== undefined) {
            var l_rot = parseInt(l_container.features.rotation);

            if (l_rot !== 0 ) {

                g_container_list[containerId].features.rotation = 0;
            }

            else {
                g_container_list[containerId].features.rotation = 90;
            }

            g_container_list[containerId].UpdateContainerVisual();

            // Stops menu from showing up
            l_container = null;
            $containerDom = null;
            event.preventDefault();
        }
    };

    //move to Deck.js
    var zoomIn = function(){
        scale = scale * (1 + 0.1);
        zoom(scale);
    };

    var zoomOut = function(){
        scale = scale * (1 - 0.1);
        zoom(scale);
    };

    var zoom = function(scale){
        $deck.css({width : (scale * 100) + "%"});
    };

    var getDomElements = function () {
        $deck = $(".deck");
        $zoomInBtn = $("#zoomInBtn");
        $zoomOutBtn = $("#zoomOutBtn");
        $rotateContainerBtn = $("#rotateContainerBtn");
        $findMatchingContainersBtn = $("#findMatchingContainers")
    };
    var attachEvents = function () {
        $zoomInBtn.unbind('click').click(zoomIn);
        $zoomOutBtn.unbind('click').click(zoomOut);
        $rotateContainerBtn.unbind('click').click(function(){

            var container = g_selected_container;

            if(g_selected_container){
                var $containerEl = $(container.divID);
                rotateContainer($containerEl);
            }

        });

        $findMatchingContainersBtn.unbind('click').click(function(){
            VRC.FindMatchingContainerModal.show();
        });

    };


    var init = function(){
        getDomElements();
        attachEvents();

        interact(".wrapper").gesturable({
            onstart: function (event) {
                var $wrapper = $('.wrapper').get(0);

            },
            onmove: function (event) {
               scale = scale * (1 + event.ds);
               zoom(scale);
                //$('#debug').text(event.clientX0);

                var $wrapper = $('.wrapper').get(0);
                $wrapper.scrollLeft = event.clientX0*scale;
            }
        });
    };

    return {
        init : init
    }
})();